import React from 'react';

export const MCSANotificationRush = () => {
    return (
        <iframe
            title="Notification Rush"
            src="/mcsa_htmls__TBD/notification_rush.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
